import { Objective } from "@models/objective.model"
import { httpRequest } from "../../http"
import { ObjectiveSerializer } from "@models/serializers/objectiveSerializer"

export class CommandUpdateObjective {
  async run(engagementId: number, objectiveId: number, objective: Objective) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/engagements/${engagementId}/objectives/${objectiveId}/`
    console.log('cmd update obj objective.population_segment_id ', objective.population_segment_id)
    try {
      const body = {
          id: objective.id,
          name: objective.name,
          average_net_tuition: objective.average_net_tuition,
          cost_per_credit_hour: objective.cost_per_credit_hour,
          average_credits_per_student: objective.average_credits_per_student,
          average_student_head_count: objective.average_student_head_count,
          typical_enrollment_rate: objective.typical_enrollment_rate,
          typical_melt_rate: objective.typical_melt_rate,
          typical_persistence_rates: objective.typical_persistence_rates,
          typical_stopout_recovery_rate:
            objective.typical_stopout_recovery_rate,
          payment_type: objective.payment_type,
          population: objective.population,
          general_audience_description: objective.general_audience_description,
          general_audience_description_notes: objective.general_audience_description_notes,
          client_name: objective.client_name,
          overall_campaign_goals: objective.overall_campaign_goals,
          population_segment: {"id": objective.population_segment_id},
          list_size: objective.list_size,
          list_age_start_date: objective.list_age_start_date,
          list_age_end_date: objective.list_age_end_date,
          list_type: objective.list_type,
          lookback_window: objective.lookback_window,
          academic_calendar_url: objective.academic_calendar_url,
        }
      console.log('body to put ', body)
      const response = await httpRequest<any>(url, {
        method: "PUT",
        body: body
      })
      return this.deserialize(response)
    } catch (error) {
      console.error("Error fetching data:", error)
      throw error
    }
  }

  deserialize(data: any): Objective {
    const serializer = new ObjectiveSerializer()
    return serializer.deserialize(data)
  }
}
